import { ReservationDailyRule } from './reservation-daily-rule';

import { Utils } from '../helpers/utils';

export class ReservationDayException {
	id: number;
	company_id: number;

	schedule: string; // datetime of the affected day/schedule
	status: 'temporarily_closed'|'closed'|'open_with_restrictions'|'open';

	description: string;
	new_max_people: number; // in case of 'open with restrictions'
	new_schedules: string; // in case of 'open with restrictions'. JSON string [{time: '12:00'}, {time: '18:00'}]

	created_at: string;
	updated_at: string;

	// set by our front end app
	statusPtbr: 'fechado temporariamente'|'fechado'|'aberto com restrições'|'aberto';
	affectedByDailyRule: ReservationDailyRule;
	possibleShifts: string[];
	auxNewSchedules: string;
	schedulesObj: {
		time: string
	}[];

	static setAdditionalData(rde: ReservationDayException) {
		rde.schedule = Utils.dateToISO(rde.schedule, true);
		rde.schedulesObj = JSON.parse(rde.new_schedules);
		rde.auxNewSchedules = "";
		if(rde.schedulesObj) {
			for(let sched of rde.schedulesObj) {
				rde.auxNewSchedules += sched.time.split(":").join("");
			}
		}
		switch(rde.status) {
			case 'temporarily_closed': {
				rde.statusPtbr = 'fechado temporariamente';
				break;
			}
			case 'closed': {
				rde.statusPtbr = 'fechado';
				break;
			}
			case 'open_with_restrictions': {
				rde.statusPtbr = 'aberto com restrições';
				break;
			}
			case 'open': {
				rde.statusPtbr = 'aberto';
				break;
			}
		}
	}

	static setArrayAditionalData(rdes: ReservationDayException[]) {
		for(let rde of rdes) {
			ReservationDayException.setAdditionalData(rde);
		}
	}

	static getCurrent(rdes: ReservationDayException[], date: Date): ReservationDayException[] {
		let res = [];
		let str = Utils.dateToISO(date);
		for(let rde of rdes) {
			if(rde.schedule.split(" ")[0] == str.split(" ")[0]) { // year, month and day match. time is ignored
				res.push(rde);
			}
		}

		return res;
	}

	// shift is in format 'HH:mm'
	static hasDailyRule(rde: ReservationDayException, rdrs: ReservationDailyRule[], shift: string = null): ReservationDailyRule {
		let date = new Date(Utils.dateToISO(rde.schedule, true));

		let found: ReservationDailyRule = null;
		for(let rdr of rdrs) {
			ReservationDailyRule.setAdditionalData(rdr);

			if(rdr.nDayOfWeek == date.getDay()) {
				if(shift) {
					for(let schedule of rdr.schedulesObj) {
						if(shift == schedule.time) {
							found = rdr;
						}
					}
				} else {
					found = rdr;
				}
			}
		}

		if(found) {
			rde.possibleShifts = [];
			for(let scheduleObj of found.schedulesObj) {
				let auxDate = new Date(date);
				let hourMinute = scheduleObj.time.split(":");
				auxDate.setHours(Number(hourMinute[0]), Number(hourMinute[1]), 0, 0);
				rde.possibleShifts.push(Utils.dateToISO(auxDate, false));
			}
		}
		rde.affectedByDailyRule = found;
		return found;
	}

	static mountSchedulesStr(rde: ReservationDayException) {
		rde.schedulesObj = [];
		if(rde.auxNewSchedules) {
			for(let i = 0; i < rde.auxNewSchedules.length; i += 4) {
				rde.schedulesObj.push({
					time: rde.auxNewSchedules.substr(i, 2) + ':' + rde.auxNewSchedules.substr(i + 2, 2)
				});
				rde.new_schedules = JSON.stringify(rde.schedulesObj);
			}
		}
	}
}